<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { Checkbox, Input } from '@/shared/ui';
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';
  import FieldRef from './FieldRef.vue';

  const lab = useMatrixFillLabContext();
  const filter = ref('');

  const fields = computed(() => {
    const needle = filter.value.trim().toLowerCase();
    return needle
      ? lab.fieldOptions.value.filter((field) => `${field.label} ${field.id}`.toLowerCase().includes(needle))
      : lab.fieldOptions.value;
  });

  const alreadyRequired = computed(
    () => new Set(lab.fieldOptions.value.filter((field) => lab.compiled.value?.fields[field.id]?.element.properties.required === true && !lab.requiredFieldIds.value.has(field.id)).map((field) => field.id)),
  );
</script>

<template>
  <div
    class="flex flex-col gap-2"
    data-testid="required-editor"
  >
    <p class="text-[11px] text-[var(--color-gray-05)]">
      Marcar um campo aqui injeta <code>required: true</code> na estrutura antes de compilar. Campos já obrigatórios na matriz aparecem marcados e não podem ser desmarcados.
    </p>
    <Input
      v-model="filter"
      placeholder="Filtrar campos"
      class="h-7 bg-white text-xs md:text-xs"
    />
    <div class="max-h-40 overflow-auto rounded-md border border-[var(--color-gray-02)] bg-[var(--color-white-01)] p-1.5">
      <label
        v-for="field in fields"
        :key="field.id"
        class="flex items-center gap-2 py-0.5"
        :class="alreadyRequired.has(field.id) ? 'cursor-not-allowed' : 'cursor-pointer'"
      >
        <Checkbox
          :id="`required-${field.id}`"
          :checked="alreadyRequired.has(field.id) || lab.requiredFieldIds.value.has(field.id)"
          :disabled="alreadyRequired.has(field.id)"
          @toggle="lab.toggleRequired(field.id)"
        />
        <FieldRef
          :id="field.id"
          :label="field.label"
          :locate="false"
        />
        <span
          v-if="alreadyRequired.has(field.id)"
          class="ml-auto shrink-0 text-[10px] text-[var(--color-gray-04)]"
        >
          da matriz
        </span>
      </label>
    </div>
  </div>
</template>
